const HOST_MAP = {
  prod: 'https://my.embarkvet.com',
  qa: 'https://privatetest.embarkvet.com',
  dev: 'https://dev1.embarkvet.com',
};

const productionHosts = ['shop.embarkvet.com', 'embark-vet.myshopify.com'];
const qaHosts = ['embark-dev-brd.myshopify.com'];

const ENV = {
  PROD: 'prod',
  QA: 'qa',
  DEV: 'dev',
};

export function getEnv(hostname = window.location.hostname) {
  if (Shopify?.theme?.role === 'development') {
    return ENV.DEV;
  }

  if (productionHosts.indexOf(hostname) > -1) {
    return ENV.PROD;
  }

  if (qaHosts.indexOf(hostname) > -1) {
    return ENV.QA;
  }
  return ENV.DEV;
}

const currentEnv = getEnv();

const MYEV_PUBLIC_HOSTNAME = HOST_MAP[ENV.PROD];
const MYEV_AUTH_HOSTNAME = HOST_MAP[currentEnv];

export const MYEV_API_BASE = `${MYEV_PUBLIC_HOSTNAME}/api`;
export const MYEV_AUTH_API_BASE = `${MYEV_AUTH_HOSTNAME}/api`;
export const MYEV_MEMBER_HOME = `${MYEV_PUBLIC_HOSTNAME}/pet-parent`;
